import lodashSet from 'lodash.set';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/redux/store';
import { questionnairesApi } from 'app/services/questionnaires';

export type TPerForeignEmployer = TPerForeignEmployerItem[];

export type TPerForeignEmployerItem = {
  foreignieNonUsEmployerName: Nullable<string>;
  isEmployerAForeignCompanyAForeignSubsidiaryOfAUsCompanyOrAUsCompany: Nullable<string>;
  employersStreetAddress: Nullable<string>;
  city: Nullable<string>;
  postCode: Nullable<string>;
  country: Nullable<string>;
  grossWagessalaryEarnedWithThisEmployerDuringYear: Nullable<string>;
  didYoureEmployerProvideAnAllowanceOnTopOfDirectSalarycarEducationHomeLeaveEtc: Nullable<string>;
  list: Nullable<string>;
  wereContributionsMadeToANonUsPensionPlanwhetherYourselfOrByYourEmployer: Nullable<string>;
  didYourEmployerContributeToYourPensionPlan: Nullable<string>;
  amountYourEmployerContributed: Nullable<string>;
};

export interface IncomeOutsideOfTheUsStateValues {
  didYouReceivePaymentsFromANonUsEmployer: Nullable<TYesOrNo>;
  didYouEarnWagesFormAUsEmployer: Nullable<TYesOrNo>;
  pleaseUploadFormW2: Nullable<string>;
  uploadAnnualNonUsWageStatementFormForeignEmployers: Nullable<string>;
  perForeignEmployer: TPerForeignEmployer;
  selectCurrency: Nullable<string>;
  calendarYearIncomeCalculator: Nullable<string>;
  descriptionOfAllowance: Nullable<string>;
  endOfForeignEmployer: Nullable<string>;
  didYouReceiveAForeignieNonUsTaxRefund: Nullable<string>;
  amountOfForeignieNonUsTaxRefund: Nullable<string>;
  didYouReceiveStockBasedCompensationFromYourEmployer: Nullable<string>;
  pleaseUploadSupportedDocumentation: Nullable<string>;
  amount: Nullable<string>;
}

export interface IncomeOutsideOfTheUsState {
  values: IncomeOutsideOfTheUsStateValues;
}

const initialState: IncomeOutsideOfTheUsState = {
  values: {
    amount: null,
    didYouReceivePaymentsFromANonUsEmployer: null,
    didYouEarnWagesFormAUsEmployer: null,
    pleaseUploadFormW2: null,
    uploadAnnualNonUsWageStatementFormForeignEmployers: null,
    perForeignEmployer: [
      {
        foreignieNonUsEmployerName: null,
        isEmployerAForeignCompanyAForeignSubsidiaryOfAUsCompanyOrAUsCompany:
          null,
        employersStreetAddress: null,
        city: null,
        postCode: null,
        country: null,
        grossWagessalaryEarnedWithThisEmployerDuringYear: null,
        didYoureEmployerProvideAnAllowanceOnTopOfDirectSalarycarEducationHomeLeaveEtc:
          null,
        list: null,
        wereContributionsMadeToANonUsPensionPlanwhetherYourselfOrByYourEmployer:
          null,
        didYourEmployerContributeToYourPensionPlan: null,
        amountYourEmployerContributed: null,
      },
    ],
    selectCurrency: null,
    calendarYearIncomeCalculator: null,
    descriptionOfAllowance: null,
    endOfForeignEmployer: null,
    didYouReceiveAForeignieNonUsTaxRefund: null,
    amountOfForeignieNonUsTaxRefund: null,
    didYouReceiveStockBasedCompensationFromYourEmployer: null,
    pleaseUploadSupportedDocumentation: null,
  },
};

const incomeOutsideOfTheUsSlice = createSlice({
  name: 'incomeOutsideOfTheUs',
  initialState,
  reducers: {
    update(state, action: PayloadAction<IncomeOutsideOfTheUsStateValues>) {
      state.values = JSON.parse(JSON.stringify(action.payload));
    },
    updateKey(
      state,
      action: PayloadAction<{
        key:
          | keyof IncomeOutsideOfTheUsStateValues
          | keyof TPerForeignEmployerItem;
        value: any;
      }>,
    ) {
      lodashSet(state, `values.${action.payload.key}`, action.payload.value);
    },
    updateFieldArrayKey(
      state,
      action: PayloadAction<{
        key:
          | keyof IncomeOutsideOfTheUsStateValues
          | keyof TPerForeignEmployerItem;
        value: TPerForeignEmployer;
      }>,
    ) {
      const fieldArray = action.payload.value.map((field) => ({ ...field }));
      if (action.payload.key === 'perForeignEmployer') {
        state.values[action.payload.key] = fieldArray;
      } else {
        lodashSet(state, `values.${action.payload.key}`, fieldArray);
      }
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      questionnairesApi.endpoints.getQuestionnaireById.matchFulfilled,
      (state, { payload }) => {
        state.values = payload.questionnaire.data.taxQuestionnaire
          ? payload.questionnaire.data.taxQuestionnaire.income.wages
              .incomeOutsideOfTheUs.values
          : initialState.values;
      },
    );
  },
});

export const { update, updateKey, updateFieldArrayKey } =
  incomeOutsideOfTheUsSlice.actions;
export default incomeOutsideOfTheUsSlice.reducer;

export const selectIncomeOutsideOfTheUs = (state: RootState) =>
  state.taxQuestionnaire.income.wages.incomeOutsideOfTheUs;
